/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button } from '@applane/react-core-components';
import {
  View, Text, ScrollView, Image,
} from '../../app-components';
import { TextInput } from '../../app-components/input-components/Editors';
import { LargeButton } from '../../app-components/buttons/Buttons';
import { FormField } from '../../app-components/form/field';
import { Form } from '../../app-components/form/Form';
import { LANDING_VIEW } from '../../Config';
import { appraiseLogo, notificationError } from '../../images';
import { ROUTES } from '../../Lib/constants';
import { isMobile } from '../../app-components/UtilityFunctions';
import { h10_Montessart } from '../../theme/fonts';
import vars from '../../theme/vars';
import './login.css'

const loginStyle = {
  leftSide: {
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    backgroundColor: '#010101',
    color: 'white',
    padding: '4% 6%',
    justifyContent: 'space-around',
  },

  loginBoxStyle: {
    flex: 1,
    overflow: 'hidden',
    borderColor: vars.colors.white,
  },

  loginText: {
    // marginBottom: !isMobile ? -32 : -20,
    zIndex: 1,
    fontFamily: 'Montessart',
    // fontSize: !isMobile ? 68 : 44,
    color: '#010101',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 35,
  },
  errorStyle: {
    ...vars.headings.h14,
    color: vars.colors.error,
    textAlign: 'center',
  },
};

export default ({ mamcAuthenticate }) => {
  const { loginText, leftSide } = loginStyle;
  return ({ navigation }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = ({ data }) => mamcAuthenticate(data).then((res) => {

      // console.log('loginNavigation', navigation)
      // if (res.enforceChangePassword) {
      //   navigation.replace(ROUTES.ResetPassword.name);
      // } else if (!res.error) {
      //   navigation.replace(LANDING_VIEW);
      // } else {
      //   throw res && res.error;
      // }

      if (res.enforceChangePassword) {
        // Use window.location.replace to change the URL without adding to history
        window.location.replace(ROUTES.ResetPassword.name);
      } else if (!res.error) {
        // Use window.location.replace to change the URL without adding to history
        window.location.replace(LANDING_VIEW);
      } else {
        throw res && res.error;
      }
    });

    const [visible, setVisiblity] = useState(false);

    const handleVisibility = () => {
      setVisiblity(!visible);
    };

    return (
      <ScrollView>
        <View
          style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}
          // className='text-center'
        >
          {/* left side started */}
          {/* class='d-none d-sm-block' */}
          <View style={leftSide}>
            <Button
              style={{ cursor: 'pointer' }}
              onClick={() => {
                // navigation.replace('landing');
                window.location.replace('/');
              }}
            >
              {/* style={{ width: '100px' }} */}
              <Image source={appraiseLogo}  className='imgLogo'/>
            </Button>
            <Text
              style={{
                fontFamily: 'Poppins',
                fontStyle: 'italic',
                fontSize: '18px',
                color: '#fafafa',
              }}
            >
              {/* Lorem ipsum dolor sit */}
            </Text>
            <View style={{ display: 'flex', gap: '30px' }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  color: '#FAFAFA',
                }}
                className='wlcm-text'
              >
                Welcome Back!
              </Text>
              <View
                style={{ border: '1px solid #FAFAFA', width: '68.5px' }}
              />
              <Text
                style={{
                  fontFamily: 'Poppins',
                  color: '#FAFAFA',
                  lineHeight: '27px',
                }}
                className='textContent'
              >
                Welcome to fully automated appraisals! Sign in and set your
                parameters in the setup page and let the software work its
                magic!
              </Text>
            </View>
          </View>
          {/* left side over */}
          <View
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '65%',
              flexDirection: !isMobile ? 'row' : 'column',
            }}
          >
            {/* right side started */}
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <View
                style={{
                  alignItems: 'center',
                }}
              >
                <Text style={loginText}>Log In</Text>
              </View>
              <ScrollView
                style={{
                  overflow: 'hidden',
                  flex: 1,
                  alignItems: !isMobile && 'center',
                }}
              >
                <Form
                  navigation={navigation}
                  scrollable={false}
                  mandatory={{
                    username: 'Username is mandatory',
                    password: 'Password is mandatory',
                  }}
                  required={{
                    username: 1,
                    password: 1,
                  }}
                  onSubmit={handleSubmit}
                  containerStyle={{
                    flex: 1,
                  }}
                  bodyContainerStyle={{
                    margin: 0,
                    flex: 1,
                  }}
                  onSubmitError={setErrorMessage}
                >
                  <LoginFormNew
                    errorMessage={errorMessage}
                    handleVisibility={handleVisibility}
                    visible={visible}
                  />
                </Form>
              </ScrollView>
            </View>
            {/* right side over */}
          </View>
        </View>
      </ScrollView>
    );
  };
};

const LoginFormNew = ({ form_context: formContext, errorMessage, visible }) => {
  const { handleSubmit, navigation } = formContext;
  const { loginBoxStyle, errorStyle } = loginStyle;

  return (
    <View
      style={{
        ...loginBoxStyle,
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        width: !isMobile && 450,
      }}
    >
      <View>
        <FormField
          field="username"
          floatingLabelStyle={{
            ...h10_Montessart,
          }}
          activeLabelStyle={{
            ...h10_Montessart,
          }}
          label="USERNAME OR EMAIL"
          variant="filled"
          onSubmitEditing={handleSubmit}
        >
          <TextInput />
        </FormField>
      </View>

      <View>
        <FormField
          field="password"
          label="PASSWORD"
          floatingLabelStyle={{
            ...h10_Montessart,
          }}
          activeLabelStyle={{
            ...h10_Montessart,
          }}
          variant="filled"
          onSubmitEditing={handleSubmit}
        >
          <TextInput inputProps={{ type: visible ? 'text' : 'password' }} />
        </FormField>
      </View>

      <View style={{ alignItems: 'center' }}>
        <LargeButton
          color="#444444"
          width="120px"
          hoverColor={null}
          label={'login.buttons.login'.getLabel()}
          labelStyle={{
            fontSize: 14,
            color: '#fafafa',
            fontFamily: 'Montserrat',
          }}
          onClick={handleSubmit}
          height={48}
          borderRadius={100}
        />
      </View>
      {errorMessage ? (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Image source={notificationError} style={{ height: 18, width: 18 }} />
          <Text style={{ ...errorStyle }}>{errorMessage}</Text>
        </View>
      ) : null}
      {/* <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          gap: '10px',
          fontFamily: 'Roboto',
          fontSize: '16px',
        }}
      >
        <Text style={{ color: '#030229' }}>Don&apos;t have account yet?</Text>

        <Button
          style={{
            color: '#605BFF',
            cursor: 'pointer',
          }}
          onClick={() => {
            // navigation.replace('contactUs');
            window.location.replace('contactUs');

          }}
        >
          Contact Us!
        </Button>
      </View> */}
    </View>
  );
};
